import React from "react";

const TermsOfService = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Terms of Service</h1>

        <p>
          Welcome to <strong>Freshcart</strong>. By accessing or using our
          website, you agree to be bound by the following Terms of Service.
          Please read them carefully before using our services.
        </p>

        <Section title="1. Acceptance of Terms">
          By using Freshcart, you agree to comply with and be legally bound by
          these terms. If you do not agree, please do not use our website.
        </Section>

        <Section title="2. Use of Our Services">
          <ul>
            <li>You must be at least 18 years old to use our services.</li>
            <li>You agree to provide accurate information while placing orders.</li>
            <li>You are responsible for maintaining your account security.</li>
          </ul>
        </Section>

        <Section title="3. Products and Pricing">
          All products are subject to availability. Prices may change without
          notice. We may cancel orders due to pricing or stock issues.
        </Section>

        <Section title="4. Order Confirmation">
          Order confirmation does not guarantee acceptance. We may cancel
          orders if required.
        </Section>

        <Section title="5. Payment Terms">
          We accept UPI, Bank Transfer, and Cash on Delivery (COD). Orders are
          processed after successful payment confirmation (except COD).
        </Section>

        <Section title="6. Delivery Policy">
          We try to deliver on time, but delays may occur due to unforeseen
          circumstances.
        </Section>

        <Section title="7. Return and Refund">
          Returns are accepted only for damaged or wrong products within 24
          hours of delivery. Refunds are processed after verification.
        </Section>

        <Section title="8. User Conduct">
          Users must not misuse the website for fraud, hacking, or harmful
          activities.
        </Section>

        <Section title="9. Intellectual Property">
          All content including logos, images, and text belongs to Freshcart and
          cannot be copied without permission.
        </Section>

        <Section title="10. Limitation of Liability">
          Freshcart is not liable for indirect or incidental damages from using
          our services.
        </Section>

        <Section title="11. Changes to Terms">
          We may update these terms anytime. Continued use means acceptance.
        </Section>

        <Section title="12. Contact Us">
          <p>
            <strong>Freshcart</strong>
            <br />
            Nijhra, Sonaili, Katihar, Bihar
            <br />
            Phone: 7856000970
            <br />
            Email: freshcart585@gmail.com
          </p>
        </Section>

        <p style={styles.updated}>Last Updated: January 2026</p>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginTop: "22px" }}>
    <h2 style={{ color: "#2c3e50" }}>{title}</h2>
    <div>{children}</div>
  </div>
);

const styles = {
  page: {
    background: "#f4f6f8",
    minHeight: "100vh",
    padding: "40px 20px",
    fontFamily: "Arial, Helvetica, sans-serif",
  },
  container: {
    maxWidth: "900px",
    margin: "auto",
    background: "#fff",
    padding: "30px",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    lineHeight: "1.7",
    color: "#333",
  },
  title: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#2c3e50",
  },
  updated: {
    marginTop: "30px",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
  },
};

export default TermsOfService;